export function Resources (pConfig)
{
  const insertResources =
        {
          insertResourceModule:
          {
            rootPath:
            {
              imageModeRootPath: BEditor.environment.topWindow.location.protocol + '//' + BEditor.environment.topWindow.location.host + '/' + 'resources' + '/' + 'Pictures',
              fileModeRootPath: BEditor.environment.topWindow.location.protocol + '//' + BEditor.environment.topWindow.location.host + '/' + 'resources' + '/' + 'Documents'
            },
            fileSortType: BEditor.UI.FileSortType.SortByDateDes,
            resources:
            {
              titles:
              {
                fileUploadTitle: 'Insert document',
                imageUploadTitle:  'Insert image',
                folderReadOnlyTitle: 'Folder is read only',
                deleteText: 'Delete',
                emptyFolderMessage: 'Folder is empty. Please upload the file to be inserted.'
              },

              sortTypes:
              {
                sortByNameAsc: 'Sort by name, A to Z',
                sortByNameDes: 'Sort by name, Z to A',
                sortByDateDes: 'Sort by date, new to old',
                sortByDateAsc: 'Sort by date, old to new',
                sortByTypeAsc: 'Sort by type, A to Z',
                sortByTypeDes: 'Sort by type, Z to A',
                sortBySizeDes: 'Sort by size, big to small',
                sortBySizeAsc: 'Sort by size, small to big'
              },

              confirmations:
              {
                deleteFile: 'Are you sure you want to delete this file?',
                deleteFolder: 'Are you sure you want to delete this folder and all its subfolders?'
              },

              buttons:
              {
                insertButtonName: 'Insert',
                cancelButtonName: 'Cancel'
              },

              toolBars:
              {
                mainToolBar:
                {
                  listViewSwitcher:
                  {
                    buttons:
                    {
                      thumbViewButtonTitle: 'Icons view',
                      tableViewButtonTitle: 'List view'
                    }
                  },
                  editFolderControl:
                  {
                    buttons:
                    {
                      addFolderButtonTitle: 'New folder',
                      renameFolderButtonTitle: 'Rename folder'
                    }
                  }
                },

                advancedToolBar:
                {
                  uploadToolBar:
                  {
                    links:
                    {
                      browseLinkTitle: 'browse'
                    },
                    buttons:
                    {
                      uploadFileButtonName: 'Browse'
                    },
                    image:
                    {
                      title: 'To upload images, drag and drop them below, or {0} your computer.',
                      keepOriginalCheckBoxTitle: 'Keep original image size'
                    },
                    file:
                    {
                      title: 'To upload files, drag and drop them below, or {0} your computer.'
                    }
                  },

                  editToolBar:
                  {
                    addFolderTitle: 'New folder name',
                    renameFolderTitle: 'Edit folder name',
                    buttons:
                    {
                      okButtonName: 'Ok'
                    },
                    warningMessages:
                    {
                      folderExists: 'Folder with the same name already exists'
                    }
                  },
                  readOnlyFolderToolBar:
                  {
                    title: 'Current folder is read only'
                  },

                  warningToolBars:
                  {
                    fileExistsToolBar:
                    {
                      buttons:
                      {
                        replaceButtonName: 'Replace',
                        skipButtonName: 'Skip'
                      },
                      warningMessages:
                      {
                        fileExists: 'There is already a file with the same name in this folder'
                      },
                      allFilesCheckBox:
                      {
                        title: 'For all these files'
                      }
                    },
                    fileIncorrectToolBar:
                    {
                      buttons:
                      {
                        skipButtonName: 'Skip'
                      },
                      warningMessages:
                      {
                        fileNameIncorrect: 'File name contains one or more unsupported characters: \\ \/ : * ? " < > | & # + %',
                        fileSizeExceed: 'File size exceeds maximum value',
                        fileTypeIncorrect: 'File has unsupported type'
                      },
                      allFilesCheckBox:
                      {
                        title: 'For all these files'
                      }
                    },
                    genericFileUploadErrorToolBar:
                    {
                      buttons:
                      {
                        repeatUploadButtonName: 'Try again',
                        skipButtonName: 'Skip'
                      },
                      warningMessages:
                      {
                        genericErrorMessage: 'Unable to upload file'
                      }
                    },
                    insufficientSpaceToolBar:
                    {
                      warningMessages:
                      {
                        insufficientSpaceErrorMessage: 'You have exceeded your storage limit. To manage existing files, go to Files within the Website module.'
                      }
                    },
                    genericRequestExceptionToolBar:
                    {
                      buttons:
                      {
                        repeatActionButtonName: 'Try again'
                      },
                      warningMessages:
                      {
                        createFolderErrorMessage: 'Unable to create folder.',
                        renameFolderErrorMessage: 'Unable to rename folder.',
                        generalRequestExceptionMessage: 'Unable to complete request because connection was lost or server is not responding. Please try again later.'
                      }
                    },
                    genericFileStructureErrorToolBar:
                    {
                      warningMessages:
                      {
                        fileStructureError: 'Folder was not found.'
                      }
                    }
                  }
                }
              },

              dragDropSelector:
              {
                  title: 'Drag\'n\'drop your files here'
              }
            }
          },

          uploadWarningManager:
          {
            alarmWindows:
            {
              fileExistsAlarmWindow:
              {
                buttons:
                {
                  replaceButtonName: 'Replace',
                  skipButtonName: 'Skip'
                },
                warningMessages:
                {
                  fileExists: 'There is already a file with the same name in this folder'
                },
                allFilesCheckBox:
                {
                  title: 'For all these files'
                }
              },
              fileIncorrectAlarmWindow:
              {
                buttons:
                {
                  skipButtonName: 'Skip'
                },
                warningMessages:
                {
                  fileNameIncorrect: 'File name contains unsupported characters<br>\\ \/ : * ? " < > | & # + %',
                  fileSizeExceed: 'File size exceeds maximum value',
                  fileTypeIncorrect: 'File has unsupported type'
                },
                allFilesCheckBox:
                {
                  title: 'For all these files'
                }
              },
              genericFileUploadErrorAlarmWindow:
              {
                buttons:
                {
                  repeatUploadButtonName: 'Try again',
                  skipButtonName: 'Skip'
                },
                warningMessages:
                {
                  genericErrorMessage: 'Unable to upload file'
                }
              },
              insufficientSpaceAlarmWindow:
              {
                warningMessages:
                {
                  insufficientSpaceErrorMessage: 'You have exceeded your storage limit. To manage existing files, go to Files within the Website module.'
                }
              },
              genericRequestExceptionAlarmWindow:
              {
                buttons:
                {
                  repeatActionButtonName: 'Try again',
                  okButtonName: 'OK'
                },
                warningMessages:
                {
                  createFolderErrorMessage: 'Unable to create folder',
                  renameFolderErrorMessage: 'Unable to rename folder',
                  generalRequestExceptionMessage: 'Unable to complete request because connection was lost or server is not responding. Please try again later.',
                  deleteFileExceptionMessage: 'Unable to delete file',
                  deleteFolderExceptionMessage: 'Unable to delete folder'
                }
              },
              genericFileStructureErrorAlarmWindow:
              {
                warningMessages:
                {
                  fileStructureError: 'Folder was not found.'
                }
              }
            }
          }
        },


        insertResourceModuleResources =
        {
          rootPath: insertResources.insertResourceModule.rootPath,
          fileSortType: insertResources.insertResourceModule.fileSortType,
          sortTypes: insertResources.insertResourceModule.sortTypes,
          resources: insertResources.insertResourceModule.resources,
          uploadWarningManager: insertResources.uploadWarningManager
        },


        sprites =
        {
          iconsSmall:
          {
            url: BEditor.environment.adminResImgPath + 'editor-all-new.png?' + BEditor.environment.version,
            buttonHeight: 28,
            spriteHeight: 168,
            icons:
            [
              {name: 'Undo', width: 28},
              {name: 'Redo', width: 28},
              {name: 'OL', width: 28},
              {name: 'UL', width: 28},
              {name: 'OutdentBlock', width: 28},
              {name: 'IndentBlock', width: 28},
              {name: 'JustifyLeft', width: 28},
              {name: 'JustifyCenter', width: 28},
              {name: 'JustifyRight', width: 28},
              {name: 'JustifyFull', width: 28},
              {name: 'ForeColor', width: 28},
              {name: 'BackColor', width: 28},
              {name: 'CopyStyle', width: 28},
              {name: 'ClearFormatting', width: 28},
              {name: 'Copy', width: 28},
              {name: 'Paste', width: 28},
              {name: 'SpellChecker', width: 28},
              {name: 'InsertSnippet', width: 28},
              {name: 'HTMLEdit', width: 43},
              {name: 'FormattingDropdown', width: 166},
              {name: 'TextFont', width: 165},
              {name: 'FontSize', width: 52},
              {name: 'LineHeight', width: 77},
              {name: 'Bold', width: 28},
              {name: 'Italic', width: 28},
              {name: 'Underline', width: 28},
              {name: 'MoreDropdown', width: 15},
              {name: 'Strikethrough', width: 28},
              {name: 'Subscript', width: 28},
              {name: 'Superscript', width: 28},
              {name: 'FormattingDropdownMini', width: 129},
              {name: 'TextFontMini', width: 128},
              {name: 'FormattingDropdownPublic', width: 161},
              {name: 'TextFontPublic', width: 160},
              {name: 'InsertLinkAndAnchorPublic', width: 28},
              {name: 'TablePublic', width: 28},
              {name: 'InsertHRPublic', width: 28},
              {name: 'MoreButton', width: 49},
              {name: 'AdditionalSpace', width: 486, height: 80},
              {name: 'EditorPollDescriptionLocalToolbar', width: 687, height: 81},
              {name: 'EditorEventDescriptionLocalToolbar', width: 567, height: 81}
            ]
          },

          iconsBig:
          {
            url: BEditor.environment.adminResImgPath + 'editor-dblsizebtn-all-new.png?' + BEditor.environment.version,
            buttonHeight: 80,
            spriteHeight: 480,
            icons:
            [
              {name: 'InsertPicture', width: 44},
              {name: 'InsertDocument', width: 44},
              {name: 'InsertLinkAndAnchor', width: 44},
              {name: 'Table', width: 44},
              {name: 'Decor', width: 44},
              {name: 'Layer', width: 44},
              {name: 'InsertArtText', width: 44},
              {name: 'InsertButton', width: 44},
              {name: 'InsertIcon', width: 44},
              {name: 'InsertHR', width: 44},
              {name: 'EmailMacrosDialog', width: 44},
              {name: 'Gadget', width: 60},
              {name: 'Layout', width: 60}
            ]
          }
        },

        spritesHash = {};


  window.editorToolbarColorsTable =
  [
    ['TTTTTT','FFFFFF','E6E6E6','CCCCCC','B3B3B3','999999','808080','666666','4D4D4D','333333','1A1A1A','000000','FF0000','FFFF00','00FF00','00FFFF','0000FF','FF00FF'],
    ['C7B299','C69C6E','F7977A','F9AD81','FDC68A','FFF79A','C4DF9B','A2D39C','82CA9D','7BCDC8','6ECFF6','7EA7D8','8493CA','8882BE','A187BE','BC8DBF','F49AC2','F6989D'],
    ['998675','A67C52','F26C4F','F79A66','FBAF5C','FFF467','ACD372','7CC576','3BB878','1ABBB4','00BFF3','438CCA','5574B9','605CA8','855FA8','A763A8','F06EA9','F26D7D'],
    ['736357','8C6239','ED1C24','F26522','F7941D','FFF200','8DC73F','39B54A','00A651','00A99D','00AEEF','0072BC','0054A6','2E3192','662D91','92278F','EC008C','ED145B'],
    ['534741','754C24','9E0B0F','A0410D','A36209','ABA000','598527','1A7B30','007236','00746B','0076A3','004B80','003471','1B1464','440E62','630460','9E005D','9E0039'],
    ['37302D','603913','790000','7B2E00','7D4900','827B00','406618','005E20','005826','005952','005B7F','003663','002157','0D004C','32004B','4B0049','7B0046','7A0026']
  ];


  window.editorSiteMainContainersId =
  [
    'idHeaderContent',
    'idPrimaryContentBlock1Content',
    'idFooterContent',
    'idMainMenuContainer'
  ];


  Object.defineProperty(this, 'insertResources', { get: () => insertResources});
  Object.defineProperty(this, 'insertResourceModuleResources', { get: () => insertResourceModuleResources});
  Object.defineProperty(this, 'sprites', { get: () => sprites});
  Object.defineProperty(this, 'spritesHash', { get: () => spritesHash});
}